/* src/app/fullname/fullname.component.scss */
.inner {
  width: auto;
  margin-left: 18.8%;
  text-align: left;
  max-width: 608px;
}
.inner h2 {
  font-family: "Campton-Bold";
  font-size: 28px;
  margin-bottom: 24px;
}
.inner .input-group {
  margin-bottom: 20px;
}
.inner p {
  margin: 50px 0px;
}
/*# sourceMappingURL=fullname.component.css.map */
